// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================
   Ticket board page (/user/tickets/:id) and its dialogs.
   Mobile first; every rule is scoped under .tkt-page or the
   root class of a portal (.tkt-dropdown-menu, .tkt-modal,
   .tkt-workflow-drawer).
   ================================================ */

.tkt-page {
  position: relative;
  max-width: 100%;
  min-width: 0;
}

/* ── Hero header ── */
.tkt-page .tkt-hero {
  position: relative;
  overflow: hidden;
  margin-bottom: var(--ds-space-4);
  padding: var(--ds-space-4);
  border-radius: var(--ds-radius-lg);
  background: linear-gradient(135deg, var(--ds-brand-deep) 0%, var(--ds-brand) 100%);
  color: var(--ds-surface);
  box-shadow: var(--ds-shadow-md);
}

.tkt-page .tkt-hero::before {
  content: "";
  position: absolute;
  top: -60px;
  inset-inline-end: -60px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  pointer-events: none;
}

.tkt-page .tkt-hero-back {
  position: relative;
  padding-inline: 0;
  color: rgba(255, 255, 255, 0.85);
}

.tkt-page .tkt-hero-back:hover {
  color: var(--ds-surface);
}

[dir="rtl"] .tkt-page .tkt-hero-back .anticon {
  transform: scaleX(-1);
}

.tkt-page .tkt-hero-title {
  position: relative;
  margin: var(--ds-space-1) 0;
  color: var(--ds-surface);
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.tkt-page .tkt-hero-subtitle {
  position: relative;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
}

/* ── Stat widgets ── */
.tkt-page .tkt-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-5);
}

.tkt-page .tkt-stat-card {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  min-width: 0;
  padding: var(--ds-space-3) var(--ds-space-4);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
}

.tkt-page .tkt-stat-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--ds-radius-md);
  font-size: 20px;
}

.tkt-page .tkt-stat-info {
  min-width: 0;
}

.tkt-page .tkt-stat-value {
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.15;
  color: var(--ds-text);
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.tkt-page .tkt-stat-label {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ds-text-2);
}

/* ── Groups section ── */
.tkt-page .tkt-section-title {
  margin: 0 0 var(--ds-space-3);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ds-text);
}

.tkt-page .tkt-groups {
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  overflow: hidden;
}

.tkt-page .tkt-groups > .ant-tabs > .ant-tabs-nav {
  margin: 0;
  padding: 0 var(--ds-space-3);
  background: var(--ds-surface-muted);
}

.tkt-page .tkt-groups > .ant-tabs > .ant-tabs-content-holder {
  padding: var(--ds-space-3);
}

.tkt-page .tkt-tab-label {
  font-weight: 600;
}

/* Empty states */
.tkt-page .tkt-empty {
  padding: var(--ds-space-8) var(--ds-space-4);
  text-align: center;
  color: var(--ds-text-muted);
}

.tkt-page .tkt-empty p {
  margin: 0;
  font-size: 14px;
}

.tkt-page .tkt-empty--large p {
  font-size: 15px;
  font-weight: 500;
}

.tkt-page .tkt-empty__icon {
  display: block;
  margin-bottom: var(--ds-space-3);
  font-size: 36px;
}

/* ── Group header (inside a tab) ── */
.tkt-page .tkt-group-header {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-4);
  padding-bottom: var(--ds-space-3);
  border-bottom: 1px solid var(--ds-border-soft);
}

.tkt-page .tkt-group-heading {
  min-width: 0;
}

.tkt-page .tkt-group-label {
  margin-bottom: 2px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--ds-brand-strong);
}

.tkt-page .tkt-group-name {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.tkt-page .tkt-group-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
}

/* ── Ticket cards ── */
.tkt-page .tkt-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 270px), 1fr));
  gap: var(--ds-space-3);
}

.tkt-page .tkt-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: var(--ds-space-4);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-inline-start: 4px solid var(--ds-border);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease;
}

.tkt-page .tkt-card-toprow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: var(--ds-space-3);
}

.tkt-page .tkt-card-toprow .ant-tag {
  margin: 0;
  flex-shrink: 0;
}

.tkt-page .tkt-card-heading {
  flex: 1;
  min-width: 0;
}

.tkt-page .tkt-card-title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--ds-text);
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tkt-page .tkt-card-time {
  margin-top: 3px;
  font-size: 12px;
  color: var(--ds-text-muted);
}

/* Custom column values: label start, value end, both cut with an ellipsis. */
.tkt-page .tkt-card-fields {
  display: grid;
  gap: 3px;
  margin-bottom: var(--ds-space-3);
}

.tkt-page .tkt-card-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: var(--ds-space-2);
  font-size: 12px;
}

.tkt-page .tkt-card-field > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tkt-page .tkt-card-field > span:first-child {
  color: var(--ds-text-muted);
}

.tkt-page .tkt-card-field > span:last-child {
  color: var(--ds-text);
  font-weight: 600;
  text-align: end;
}

.tkt-page .tkt-card-divider {
  height: 1px;
  margin: auto 0 var(--ds-space-3);
  border: none;
  background: var(--ds-border-soft);
}

.tkt-page .tkt-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--ds-space-2);
}

.tkt-page .tkt-card-team {
  min-width: 0;
}

.tkt-page .tkt-team-label {
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--ds-text-muted);
}

.tkt-page .tkt-team-empty {
  font-size: 12px;
}

.tkt-page .tkt-member-avatar {
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.tkt-page .tkt-card-actions {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-shrink: 0;
}

/* Member task list (Popover, rendered in a portal) */
.tkt-member-tasks {
  min-width: min(200px, 70vw);
  max-width: min(320px, 80vw);
}

.tkt-member-tasks .tkt-member-task {
  padding: 6px 0;
  border-bottom: 1px solid var(--ds-border-soft);
}

.tkt-member-tasks .tkt-member-task:last-child {
  border-bottom: none;
}

.tkt-member-tasks .tkt-member-task__title {
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.tkt-member-tasks .tkt-member-task__time {
  font-size: 11px;
  color: var(--ds-text-muted);
}

/* ── Card "more" menu (Dropdown, rendered in a portal) ── */
.tkt-dropdown-menu {
  min-width: 170px;
  padding: 6px;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-lg);
}

.tkt-dropdown-menu .ant-btn {
  justify-content: flex-start;
  width: 100%;
}

/* ── Loading overlay: covers only the ticket page, not the app shell ── */
.tkt-page .tkt-spinner-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  min-height: 240px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 160px;
  background: rgba(241, 246, 249, 0.75);
  border-radius: var(--ds-radius-lg);
}

/* ── Workflow drawer ── */
.tkt-workflow-drawer .tkt-drawer-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

/* ── Ticket / group / board dialogs ── */
.tkt-modal .tkt-modal-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.tkt-modal .tkt-modal-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.tkt-modal .tkt-modal-section {
  padding: var(--ds-space-4);
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-md);
}

.tkt-modal .tkt-modal-section__title {
  display: block;
  margin-bottom: var(--ds-space-3);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--ds-text-2);
}

.tkt-modal .tkt-column-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--ds-space-2);
  padding: 10px;
  background: var(--ds-surface);
  border-radius: var(--ds-radius-md);
}

.tkt-modal .tkt-column-row__name {
  flex: 1 1 140px;
  min-width: 0;
  margin: 0;
}

.tkt-modal .tkt-column-row__type {
  flex: 1 1 110px;
  min-width: 0;
  margin: 0;
}

/* ── Tablets and up ── */
@media (min-width: 768px) {
  .tkt-page .tkt-hero {
    padding: var(--ds-space-6) var(--ds-space-8);
    border-radius: var(--ds-radius-xl);
  }

  .tkt-page .tkt-hero-title {
    font-size: 2rem;
  }

  .tkt-page .tkt-group-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .tkt-page .tkt-groups > .ant-tabs > .ant-tabs-nav {
    padding: 0 var(--ds-space-6);
  }

  .tkt-page .tkt-groups > .ant-tabs > .ant-tabs-content-holder {
    padding: var(--ds-space-6);
  }

  .tkt-modal .tkt-column-row__type {
    flex: 0 1 140px;
  }
}

@media (hover: hover) {
  .tkt-page .tkt-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--ds-shadow-md);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/tickets/ticket.css"],"names":[],"mappings":"AAAA;;;;;qDAKqD;;AAErD;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,kFAAkF;EAClF,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sEAAsE;EACtE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uEAAuE;EACvE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,+CAA+C;EAC/C,kCAAkC;EAClC,+BAA+B;EAC/B;;yBAEuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE;IACE,4CAA4C;IAC5C,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;AACF","sourcesContent":["/* ================================================\n   Ticket board page (/user/tickets/:id) and its dialogs.\n   Mobile first; every rule is scoped under .tkt-page or the\n   root class of a portal (.tkt-dropdown-menu, .tkt-modal,\n   .tkt-workflow-drawer).\n   ================================================ */\n\n.tkt-page {\n  position: relative;\n  max-width: 100%;\n  min-width: 0;\n}\n\n/* ── Hero header ── */\n.tkt-page .tkt-hero {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: var(--ds-space-4);\n  padding: var(--ds-space-4);\n  border-radius: var(--ds-radius-lg);\n  background: linear-gradient(135deg, var(--ds-brand-deep) 0%, var(--ds-brand) 100%);\n  color: var(--ds-surface);\n  box-shadow: var(--ds-shadow-md);\n}\n\n.tkt-page .tkt-hero::before {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  inset-inline-end: -60px;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.07);\n  pointer-events: none;\n}\n\n.tkt-page .tkt-hero-back {\n  position: relative;\n  padding-inline: 0;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.tkt-page .tkt-hero-back:hover {\n  color: var(--ds-surface);\n}\n\n[dir=\"rtl\"] .tkt-page .tkt-hero-back .anticon {\n  transform: scaleX(-1);\n}\n\n.tkt-page .tkt-hero-title {\n  position: relative;\n  margin: var(--ds-space-1) 0;\n  color: var(--ds-surface);\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.tkt-page .tkt-hero-subtitle {\n  position: relative;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 14px;\n}\n\n/* ── Stat widgets ── */\n.tkt-page .tkt-stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-5);\n}\n\n.tkt-page .tkt-stat-card {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  min-width: 0;\n  padding: var(--ds-space-3) var(--ds-space-4);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.tkt-page .tkt-stat-icon {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--ds-radius-md);\n  font-size: 20px;\n}\n\n.tkt-page .tkt-stat-info {\n  min-width: 0;\n}\n\n.tkt-page .tkt-stat-value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1.15;\n  color: var(--ds-text);\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.tkt-page .tkt-stat-label {\n  margin-top: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ds-text-2);\n}\n\n/* ── Groups section ── */\n.tkt-page .tkt-section-title {\n  margin: 0 0 var(--ds-space-3);\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.tkt-page .tkt-groups {\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  overflow: hidden;\n}\n\n.tkt-page .tkt-groups > .ant-tabs > .ant-tabs-nav {\n  margin: 0;\n  padding: 0 var(--ds-space-3);\n  background: var(--ds-surface-muted);\n}\n\n.tkt-page .tkt-groups > .ant-tabs > .ant-tabs-content-holder {\n  padding: var(--ds-space-3);\n}\n\n.tkt-page .tkt-tab-label {\n  font-weight: 600;\n}\n\n/* Empty states */\n.tkt-page .tkt-empty {\n  padding: var(--ds-space-8) var(--ds-space-4);\n  text-align: center;\n  color: var(--ds-text-muted);\n}\n\n.tkt-page .tkt-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.tkt-page .tkt-empty--large p {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.tkt-page .tkt-empty__icon {\n  display: block;\n  margin-bottom: var(--ds-space-3);\n  font-size: 36px;\n}\n\n/* ── Group header (inside a tab) ── */\n.tkt-page .tkt-group-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-4);\n  padding-bottom: var(--ds-space-3);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.tkt-page .tkt-group-heading {\n  min-width: 0;\n}\n\n.tkt-page .tkt-group-label {\n  margin-bottom: 2px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--ds-brand-strong);\n}\n\n.tkt-page .tkt-group-name {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.tkt-page .tkt-group-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n/* ── Ticket cards ── */\n.tkt-page .tkt-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 270px), 1fr));\n  gap: var(--ds-space-3);\n}\n\n.tkt-page .tkt-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: var(--ds-space-4);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-inline-start: 4px solid var(--ds-border);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  transition:\n    transform 0.18s ease,\n    box-shadow 0.18s ease;\n}\n\n.tkt-page .tkt-card-toprow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: var(--ds-space-3);\n}\n\n.tkt-page .tkt-card-toprow .ant-tag {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.tkt-page .tkt-card-heading {\n  flex: 1;\n  min-width: 0;\n}\n\n.tkt-page .tkt-card-title {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tkt-page .tkt-card-time {\n  margin-top: 3px;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n/* Custom column values: label start, value end, both cut with an ellipsis. */\n.tkt-page .tkt-card-fields {\n  display: grid;\n  gap: 3px;\n  margin-bottom: var(--ds-space-3);\n}\n\n.tkt-page .tkt-card-field {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);\n  gap: var(--ds-space-2);\n  font-size: 12px;\n}\n\n.tkt-page .tkt-card-field > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tkt-page .tkt-card-field > span:first-child {\n  color: var(--ds-text-muted);\n}\n\n.tkt-page .tkt-card-field > span:last-child {\n  color: var(--ds-text);\n  font-weight: 600;\n  text-align: end;\n}\n\n.tkt-page .tkt-card-divider {\n  height: 1px;\n  margin: auto 0 var(--ds-space-3);\n  border: none;\n  background: var(--ds-border-soft);\n}\n\n.tkt-page .tkt-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.tkt-page .tkt-card-team {\n  min-width: 0;\n}\n\n.tkt-page .tkt-team-label {\n  margin-bottom: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--ds-text-muted);\n}\n\n.tkt-page .tkt-team-empty {\n  font-size: 12px;\n}\n\n.tkt-page .tkt-member-avatar {\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tkt-page .tkt-card-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-shrink: 0;\n}\n\n/* Member task list (Popover, rendered in a portal) */\n.tkt-member-tasks {\n  min-width: min(200px, 70vw);\n  max-width: min(320px, 80vw);\n}\n\n.tkt-member-tasks .tkt-member-task {\n  padding: 6px 0;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.tkt-member-tasks .tkt-member-task:last-child {\n  border-bottom: none;\n}\n\n.tkt-member-tasks .tkt-member-task__title {\n  font-size: 12px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.tkt-member-tasks .tkt-member-task__time {\n  font-size: 11px;\n  color: var(--ds-text-muted);\n}\n\n/* ── Card \"more\" menu (Dropdown, rendered in a portal) ── */\n.tkt-dropdown-menu {\n  min-width: 170px;\n  padding: 6px;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  box-shadow: var(--ds-shadow-lg);\n}\n\n.tkt-dropdown-menu .ant-btn {\n  justify-content: flex-start;\n  width: 100%;\n}\n\n/* ── Loading overlay: covers only the ticket page, not the app shell ── */\n.tkt-page .tkt-spinner-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  min-height: 240px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 160px;\n  background: rgba(241, 246, 249, 0.75);\n  border-radius: var(--ds-radius-lg);\n}\n\n/* ── Workflow drawer ── */\n.tkt-workflow-drawer .tkt-drawer-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* ── Ticket / group / board dialogs ── */\n.tkt-modal .tkt-modal-title {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.tkt-modal .tkt-modal-subtitle {\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.tkt-modal .tkt-modal-section {\n  padding: var(--ds-space-4);\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-md);\n}\n\n.tkt-modal .tkt-modal-section__title {\n  display: block;\n  margin-bottom: var(--ds-space-3);\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--ds-text-2);\n}\n\n.tkt-modal .tkt-column-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: var(--ds-space-2);\n  padding: 10px;\n  background: var(--ds-surface);\n  border-radius: var(--ds-radius-md);\n}\n\n.tkt-modal .tkt-column-row__name {\n  flex: 1 1 140px;\n  min-width: 0;\n  margin: 0;\n}\n\n.tkt-modal .tkt-column-row__type {\n  flex: 1 1 110px;\n  min-width: 0;\n  margin: 0;\n}\n\n/* ── Tablets and up ── */\n@media (min-width: 768px) {\n  .tkt-page .tkt-hero {\n    padding: var(--ds-space-6) var(--ds-space-8);\n    border-radius: var(--ds-radius-xl);\n  }\n\n  .tkt-page .tkt-hero-title {\n    font-size: 2rem;\n  }\n\n  .tkt-page .tkt-group-header {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .tkt-page .tkt-groups > .ant-tabs > .ant-tabs-nav {\n    padding: 0 var(--ds-space-6);\n  }\n\n  .tkt-page .tkt-groups > .ant-tabs > .ant-tabs-content-holder {\n    padding: var(--ds-space-6);\n  }\n\n  .tkt-modal .tkt-column-row__type {\n    flex: 0 1 140px;\n  }\n}\n\n@media (hover: hover) {\n  .tkt-page .tkt-card:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--ds-shadow-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
